import DropzoneUploader from './DropzoneUploader';
import SimpleLayout from './layouts/simple/SimpleLayout';
import BoxedPreview from './previews/boxedPreview/BoxedPreview';
import SimpleInputField from './inputFields/simlpe/SimpleInputField';
import AvatarPreview from './previews/avatarPreview/AvatarProfilePicPreview';
import { FILE_UPLOAD_STATES } from './constants';

DropzoneUploader.SimpleLayout = SimpleLayout;
DropzoneUploader.BoxedPreview = BoxedPreview;
DropzoneUploader.SimpleInput = SimpleInputField;
DropzoneUploader.AvatarPreview = AvatarPreview;
DropzoneUploader.UPLOAD_STATES = FILE_UPLOAD_STATES;

export default DropzoneUploader;
